import React from 'react';

import {colourSlots} from "./colour-editor";
import Combobox from "../components/combobox";
import {selectElement, iframeCx} from "./wireframe-editor";
import Latch, {LatchController} from '../components/latch-button';
import {Notification, Popup} from "../components/popups";

export default function SemanticButton(props: {}) {
	const getIframe = React.useContext(iframeCx)!;

	const abort = new AbortController();
	const latch = new LatchController();

	latch.bind({
		async onLatch() {
			const iframe = getIframe();

			const element = await selectElement(iframe, abort.signal);

			latch.unlatch();

			const onSubmit = (data: FormData) => {
				console.log(data);
			};

			Popup({
				id: 'semantic-colour-editor',
				children: <SemanticColourBody onSubmit={onSubmit} iframe={iframe} el={element} />
			})
		},
		onCancel() {

		},
		onEnd() {

		}
	})

	return <Latch controller={latch} data-icon={'\uf351'}>
		Semantische Farbe definieren
	</Latch>
}

const extractSemanticColour = (el: HTMLElement, prop: 'borderColor' | 'backgroundColor' | 'color') => {
	const val = el.style?.getPropertyValue(prop);
	const colour = /^var\((--wf-[^)]+)\)$/.exec(val);

	if (!colour?.[1] || !(colourSlots as readonly string[]).includes(colour[1]))
		return null;

	return colour[0];
};

function SemanticColourBody(props: { onSubmit: (data: FormData) => void, iframe: HTMLIFrameElement, el: HTMLElement }) {
	const [border, setBorder] = React.useState(extractSemanticColour(props.el, 'borderColor'));
	const [background, setBackground] = React.useState(extractSemanticColour(props.el, 'backgroundColor'));
	const [foreground, setForeground] = React.useState(extractSemanticColour(props.el, 'color'));

	React.useEffect(() => console.log(border, background, foreground), [border, background, foreground]);

	React.useEffect(() => {
		if (border)
			props.el.style.borderColor = border;
	}, [border]);
	React.useEffect(() => {
		if (background)
			props.el.style.backgroundColor = background;
	}, [background]);
	React.useEffect(() => {
		if (foreground)
			props.el.style.color = foreground;
	}, [foreground]);

	const colour: string[] = [...colourSlots];
	const toColourInvocation = (value: string) => colour.includes(value) || value.startsWith('--') ? `var(${value})` : value || null;

	return <>
		<button className="symbolic close-btn" data-icon={"\ue5cd"}
				// @ts-ignore
				command="request-close"
				commandfor="semantic-colour-editor"/>

		<form action={data => props.onSubmit(data)}>
			<div className="dialog-header">
				<h1>Semantische Farbe festlegen</h1>
			</div>

			{/* @ts-ignore */}
			<button type='button' className="symbolic close-btn" data-icon={"\ue5cd"} command="request-close"
					commandfor="semantic-colour-editor"/>

			{/*<Breadcrumbs el={original}/>*/}

			<div className='semantic-colour-property' id='semantic-colour-border'>
				<span data-icon={'\ue887'} title={'Umrissfarbe'}/>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<rect x="1" y="1" width="22" height="22" rx="5" ry="5" style={{
						stroke: border || 'currentColor',
						strokeWidth: 2,
						fill: 'rgba(110, 110, 110, 0.18)'
					}}/>
				</svg>

				<Combobox values={colour} onChange={value => setBorder(toColourInvocation(value))}
				          style={{fontFamily: 'monospace'}}/>
			</div>
			<div className='semantic-colour-property' id='semantic-colour-background'>
				<span data-icon={'\ue887'} title={'Hintergrundfarbe'}/>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<rect x="1" y="1" width="22" height="22" rx="5" ry="5" style={{
						strokeWidth: 2,
						stroke: 'rgba(110, 110, 110, 0.18)',
						fill: background || 'currentColor',
					}}/>
				</svg>

				<Combobox values={colour} onChange={value => setBackground(toColourInvocation(value))}
				          style={{fontFamily: 'monospace'}}/>

			</div>
			<div className='semantic-colour-property' id='semantic-colour-foreground'>
				<span data-icon={'\ue887'} title={'Textfarbe'}/>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<rect x="1" y="1" width="22" height="22" rx="5" ry="5" style={{
						strokeWidth: 2,
						fill: 'rgba(110, 110, 110, 0.18)'
					}}/>
					<text x="3.984" y="19.693" style={{
						fill: foreground || 'currentColor',
						fontFamily: 'sans-serif',
						fontSize: 22.2,
						fontWeight: 700,
					}}>A
					</text>
				</svg>

				<Combobox values={colour} onChange={value => setForeground(toColourInvocation(value))}
				          style={{fontFamily: 'monospace'}}/>

			</div>
		</form>
	</>
}